function bootstrapTooltips() {
  let tooltips = document.querySelectorAll('[data-js-tooltip]')
  for (let i = 0; i < tooltips.length; i++) {
    let elem = tooltips[i]
    elem.addEventListener(
      'mouseenter',
      () => (elem.querySelector('.tooltip__box').style.display = 'block')
    )
    elem.addEventListener(
      'mouseleave',
      () => (elem.querySelector('.tooltip__box').style.display = 'none')
    )
  }
}

bootstrapTooltips()
